<template>
    <div style="position: relative;">
        <NavBar :index="6" />
        <!-- 轮播图 -->
        <img class="top-nav" src="../assets/tops.png" alt="返回顶部" @click="topOne">
        <swiper :options="swiperOption" ref="mySwiper" id="mySwiper">
            <!-- 轮播图0 -->
            <swiper-slide class="swiper_slide_item">
                <swiper :options="swiperTop" ref="swiperTop" id="swiperTop">
                    <swiper-slide>
                        <div class="one-card"
                            style=" border-radius: 0; position: relative; width: 100vw; height: 100vh;margin: 0;">
                            <video src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/8%E6%9C%888%E6%97%A5.mp4"
                                autoplay muted loop
                                style="position: absolute; top: 0; left: 0; width: 100vw; height: 100%; object-fit: cover;"
                                preload="auto">
                            </video>
                            <div class="textara">
                                <div class="text-cons">加入我们</div>
                                <div class="text-fonts">携手创造更好的明天</div>
                            </div>
                        </div>
                    </swiper-slide>
                    <!--分页器-->
                    <!-- <div class="top-pagination" slot="pagination"></div> -->
                </swiper>
                <!-- Tab 导航 - 使用与businessList相同的样式 -->
                <div class="top-business-con">
                    <div class="tab-nav">
                        <div v-for="(tab, index) in topTabs" :key="index"
                            :class="['tab-item', { active: index === 0 }]" @click="switchTopTab(index)">
                            {{ tab.name }}
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!--必须的组件-->
            <!--每页幻灯片使用swiper-slide标签-->
            <!-- 1合作方式-->
            <swiper-slide class="swiper_slide_item">
                <div class="tit-news" :class="activeIndex == 1 ? 'animated-news-item' : ''">招贤纳才</div>
                <div class="twos-con">
                    <div class="zuob">
                        <swiper :options="swiperSlideOur" ref="swiperSlideOur" id="swiperSlideOur"
                            :class="activeIndex == 1 ? 'animated-news-item' : ''">
                            <swiper-slide>
                                <img src="../assets/logoing.jpg" alt="">
                            </swiper-slide>
                            <swiper-slide>
                                <img src="../assets/sans.jpg" alt="">
                            </swiper-slide>
                            <swiper-slide>
                                <img src="../assets/ers.jpg" alt="">
                            </swiper-slide>
                            <swiper-slide>
                                <img src="../assets/huiyi.jpg" alt="">
                            </swiper-slide>
                            <swiper-slide>
                                <img src="../assets/zhgggg.jpg" alt="">
                            </swiper-slide>
                            <swiper-slide>
                                <img src="../assets/ais.jpg" alt="">
                            </swiper-slide>
                            <!--分页器-->
                            <div class="swiperSlideOur-lide" slot="pagination"
                                style=" gap: 10px; display: flex;align-items: center;justify-content: center; margin-top: 30px;">
                            </div>
                        </swiper>
                    </div>
                    <div class="youb" :class="activeIndex == 1 ? 'animated-partner-row-delay1' : ''">
                        <div class="nes-tit">WHY JOIN US?</div>
                        <div class="img-nes">
                            <img src="../assets/jrwm.png" alt="">
                        </div>
                        <div class="font-nes">
                            我们是一个多元化、勇敢、智慧、协作、开放的团队，我们来自五湖四海，拥有不同的成长背景，专业知识，观点也不尽相同，但我们拥有同样的目标和价值观。
                        </div>
                        <div class="img-nes">
                            <img src="../assets/jhdd.png" alt="">
                        </div>
                        <div class="jhdd">
                            持续的成长空间，个人能力的提升，自我价值的实现。
                        </div>
                        <div class="nes-but">
                            <div class="butadd" @click="jumpgw">查看岗位</div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <!--2团队风采-->
            <swiper-slide class="swiper_slide_item">
                <div class="sy-tits" :class="activeIndex == 2 ? 'animated-news-item' : ''">团队风采</div>
                <div class="swiper-slide">
                    <div class="image-container" :class="activeIndex == 2 ? 'animated-news-item' : ''">
                        <img src="../assets/jrqi.jpg" alt="" class="custom-image">
                        <img src="../assets/jrba.jpg" alt="" class="custom-image">
                        <img src="../assets/jrliu.jpg" alt="" class="custom-image">
                    </div>
                    <div class="image-container" :class="activeIndex == 2 ? 'animated-partner-row-delay1' : ''">
                        <img src="../assets/jrsi.jpg" alt="" class="custom-image">
                        <img src="../assets/jrwu.jpg" alt="" class="custom-image">
                        <img src="../assets/jrs.jpg" alt="" class="custom-image">
                    </div>
                    <div class="image-container" :class="activeIndex == 2 ? 'animated-news-item' : ''">
                        <img src="../assets/jry.jpg" alt="" class="custom-image">
                        <img src="../assets/jrzh.jpg" alt="" class="custom-image">
                        <img src="../assets/hz.jpg" alt="" class="custom-image">
                    </div>
                </div>
            </swiper-slide>
            <!-- 3合作流程 -->
            <swiper-slide class="swiper_slide_item">
                <div class="video-td">
                    <video ref="video12"
                        src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/5dd1a2f714c770d7d208bc87e0227a41_raw.mp4"
                        autoplay muted style="width: 100vw; height: 100vh; object-fit: contain;" preload="auto">
                    </video>
                    <div class="video-tds">
                        <div class="td-con" :class="activeIndex == 3 ? 'animated-news-item' : ''">
                            合作流程
                        </div>
                    </div>
                    <div class="join-btn" @click="jumpweb">
                        加入合作计划
                    </div>
                </div>
            </swiper-slide>
            <!-- 4联系方式 -->
            <swiper-slide class="swiper_slide_item">
                <div class="video-td">
                    <video ref="video13"
                        src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/5c6544187ceb4532d2cb3f9b0a424dcd_raw.mp4"
                        autoplay muted style="width: 100vw; height: 90vh; object-fit: contain;" preload="auto">
                    </video>
                    <div class="video-tds">
                        <div class="td-con" :class="activeIndex == 4 ? 'animated-news-item' : ''">
                            联系方式
                        </div>
                        <p class="td-tit" :class="activeIndex == 4 ? 'animated-news-item' : ''">
                            未来已来,智慧谷诚邀您共同迈入数字化新时代！若您有任何合作意向,请拔打我们的官方服务专线：400-8537-168,我们将竭诚为您服务!
                        </p>
                    </div>
                </div>
            </swiper-slide>
            <!-- 6底部-->
            <swiper-slide class="swiper_slide_item">
                <!-- 底部 -->
                <div class="card-imgs" :class="activeIndex == 5 ? 'animated-image' : ''">
                    <video
                        src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/901c15307e666d31943878a152a23e61_raw.mp4"
                        autoplay muted loop style="width: 100%; height: 100%;  object-fit: cover;" preload="auto">
                    </video>
                    <div class="gradient-con">
                        <div class="gradient-text ">链上生态互融 共享数字未来</div>
                        <div class="gradient-p">智慧谷-您的企业数改服务商</div>
                    </div>
                </div>
                <div class="footer" :class="activeIndex == 5 ? 'animated-image' : ''">
                    <div class="footer_top">
                        <!-- 左 -->
                        <div class="footerTopLeft">
              <!-- 1 -->
              <div class="LeftCon" style="cursor: pointer;">
                <h4 @click="jumps(0)">走进智慧谷</h4>
                <p @click="jumps(1)">集团介绍</p>
                <p @click="jumps(5)">发展历程</p>
                <p @click="jumps(7)">企业荣誉</p>
              </div>
              <div class="LeftCon" style="cursor: pointer;">
                <h4 @click="jumphx(0)">核心业务</h4>
                <p  @click="jumphx(5)">CHAIN企业链改服务</p>
                <p  @click="jumphx(8)">企链通DAPP数商平台</p>
                <p  @click="jumphx(11)">智慧谷AI名片</p>
              </div>
              <div class="LeftCon" style="cursor: pointer;">
                <h4 @click="jumpcj(0)">应用场景</h4>
                <p @click="jumpcj(2)">数字支付</p>
                <p @click="jumpcj(3)">数字商城</p>
                <p @click="jumpcj(19)">数字三农</p>
              </div>
              <div class="LeftCon" style="cursor: pointer;">
                <h4 @click="jumpgh(0)">合作规划</h4>
                <p @click="jumpgh(1)">合作流程</p>
                <p @click="jumpgh(2)">合作收益</p>
                <p @click="jumpgh(4)">全球战略</p>
              </div>
            </div>
                        <!-- 右 -->
                        <div class="footerTopRight">
                            <!-- 1 -->
                            <!-- <div class="RightCon" style="font-size: 20px;">
                          <p style="cursor: pointer;">联系我们</p>
                      </div> -->
                            <div class="RightCon">
                                <img src="../assets/tel.png" mode=""></img>
                                <p>电话：400-8537-168</p>
                            </div>
                            <div class="RightCon">
                                <img src="../assets/web.png" mode=""></img>
                                <p style="cursor: pointer;">网址：www.gjzhg.com</p>
                            </div>
                            <div class="RightCon">
                                <img src="../assets/email.png" mode=""></img>
                                <p style="cursor: pointer;">邮箱：zhgjt@gjzhg.com</p>
                            </div>
                            <div class="RightCon">
                                <img src="../assets/dz.png" mode=""></img>
                                <p style="cursor: pointer;">地址：福建省厦门市集美区杏林湾营运中心总部大厦6号楼</p>
                            </div>
                            <!-- code -->
                            <div class="code">
                                <div
                                    style="display: flex; align-items: center; justify-content: center;flex-direction: column;">
                                    <img src="../assets/gzh.jpg" alt=""
                                        style="width: 90px;height: 90px;border-radius: 10px;">
                                    <h5 style="cursor: pointer;">扫一扫关注我们</h5>
                                </div>
                                <div
                                    style="display: flex; align-items: center; justify-content: center;flex-direction: column;">
                                    <img src="../assets/kf.png" alt=""
                                        style="width: 90px;height: 90px;border-radius: 10px;">
                                    <h5 style="cursor: pointer;">扫一扫添加客服</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="footer_botm">
                        <p style="text-indent:1em;">版权所有：智慧谷(福建)数字科技集团有限公司</p>
                        <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
                        <p style="text-indent:1em;">闽ICP备16005520号-1</p>
                        <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
                        <p style="text-indent:1em;">本网站由阿里云提供云计算及安全服务 </p>
                        <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
                        <p style="text-indent:1em;"> 本网站支持 IPv6 </p>
                        <p style="text-indent:1em;">|</p>
                        <p style="text-indent:1em;"> Powered by CloudDream </p>
                    </div>
                </div>
            </swiper-slide>
            <!-- 可选的控件 -->
            <!--分页器-->
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>
<script>
import NavBar from '../components/NavBar.vue';


export default {
    components: {
        NavBar
    },
    name: "FullPage",
    data() {
        return {
            activeIndex: 0,
            newsData: [],//循环新闻
            // 核心业务
            pageIndex: 0,
            businessActive: 0,
            timeoutId: null,    // 用于清除 15 秒超时的计时器
            intervalId: null,   // 用于清除自动切换 tab 的定时器
            // 导航栏
            topTabActive: 0,
            topTabs: [
                { name: '招贤纳才' },
                { name: '团队风采' },
                { name: '招商加盟' },
                { name: '联系我们' },
            ],
            // swiper 配置
            swiperOption: {
                direction: "vertical", // swiper 方向
                mousewheel: true,
                // 分页器
                pagination: {
                    el: ".swiper-pagination", //分页器的类名
                    clickable: true, // 点击分页器跳切换到相应的幻灯片
                },
                on: {
                    // 翻页
                    slideChange: () => {
                        // 记录当前页index
                        this.activeIndex = this.$refs.mySwiper.$swiper.activeIndex
                        console.log(this.activeIndex, ' this.activeIndex')
                    },
                }
            },
            // 顶部
            swiperSlideOur: {
                direction: "horizontal", // swiper 方向
                autoplay: true,
                mousewheel: true,
                // 分页器
                pagination: {
                    el: ".swiperSlideOur-lide", //分页器的类名
                    clickable: true, // 点击分页器跳切换到相应的幻灯片
                },
            },
            swiperSlideGallery: {
                pagination: {
                    el: '.custom-swiper-pagination',
                    clickable: true,
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
            },
            swiperOptionTeam: {
                autoplay: true,
                effect: 'coverflow',
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 4,
                coverflowEffect: {
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true,
                },
                // 分页器
                pagination: {
                    el: ".swiper-pagination", //分页器的类名
                    clickable: true, // 点击分页器跳切换到相应的幻灯片
                },
                on: {
                    // 翻页
                    slideChange: () => {
                        // 记录当前页index
                        this.activeIndex = this.$refs.mySwiper.$swiper.activeIndex
                        console.log(this.activeIndex, ' this.activeIndex')
                    },
                }
            },
        };
    },
    mounted() {

        // 初始化定时器,开始监听
        this.autoSwitchTab();
        this.resetTimeout();
        // this.getNews();
        let that = this
        if (that.$route.query.num && that.$route.query.num != 0) {
            this.topTabActive = that.$route.query.num * 1;
            if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
                that.$refs.mySwiper.$swiper.slideTo((that.$route.query.num * 1) + 0);
                console.log((that.$route.query.num * 1) + 1);
            }
        } else {
            this.topTabActive = 0;
            if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
                that.$refs.mySwiper.$swiper.slideTo(0);
            }
        }
    },

    watch: {
        // 监听 businessActive 变量的变化
        businessActive(newVal, oldVal) {
            // 每次 businessActive 变化时,重置15秒的计时器
            clearTimeout(this.timeoutId);
            this.resetTimeout();
        },
        // 视频切换一直播放
        activeIndex(newVal, oldVal) {
            // console.log(newVal, oldVal,'ppppppp');
            if (newVal == 3) {
                let video = this.$refs.video12;  // 获取视频元素
                if (video) {
                    video.currentTime = 0;  // 将视频播放时间重置为 0
                    video.play();  // 播放视频
                }
            }
            // 链改服务内容
            if (newVal == 4) {
                let video = this.$refs.video13;  // 获取视频元素
                if (video) {
                    video.currentTime = 0;  // 将视频播放时间重置为 0
                    video.play();  // 播放视频
                }
            }
        },
        // 页面需要
        '$route.query.num': function (newNum) {
            // 这里是num变化时执行的操作
            let that = this
            if (that.$route.query.num != 0) {
                console.log('num changed:', newNum);
                this.topTabActive = that.$route.query.num * 1;
                console.log(that.$route.query.num)
                if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
                    that.$refs.mySwiper.$swiper.slideTo((that.$route.query.num * 1) + 0);
                    console.log((that.$route.query.num * 1) + 1);
                }
            } else {
                console.log('num chassssnged:', newNum);

                this.topTabActive = 0;
                if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
                    that.$refs.mySwiper.$swiper.slideTo(0);
                }
            }
        }
    },
    methods: {
        // 轮播图的tab
        switchTopTab(index) {
            console.log(index);
            this.topTabActive = index;
            // 同步轮播图
            if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
                this.$refs.mySwiper.$swiper.slideTo(index + 1);
            }
        },
        switchTab(index) {
            this.businessActive = index;
            this.pageIndex = index;
            // 清除定时器,重置 15 秒的计时
            clearTimeout(this.timeoutId);
            // 重启15秒监控
            this.resetTimeout();

            // 如果有正在进行的定时器,清除并重新启动自动切换定时器
            clearInterval(this.intervalId);
            // this.autoSwitchTab();
        },

        // 自动切换 tab
        // autoSwitchTab() {
        //     this.intervalId = setInterval(() => {
        //         // 自动切换到下一个 tab
        //         this.businessActive = (this.businessActive + 1) % this.businessList.length;
        //         this.pageIndex = this.businessActive;
        //     }, 10000); // 每 10 秒切换一次
        // },

        // 监控 businessActive 的变化,如果15秒没有变化则触发 autoSwitchTab
        // resetTimeout() {
        //     this.timeoutId = setTimeout(() => {
        //         this.autoSwitchTab(); // 如果15秒内没有变化,触发自动切换 tab
        //     }, 15000); // 15秒没有变化则触发
        // },
        // 5个
        jumps(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'IntoZhg', query: { num: a, time: timestamp } })
        },

        jumphx(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'DevelopmentStrategy', query: { num: a, time: timestamp } })
        },

        jumpcj(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'core', query: { num: a, time: timestamp } })
        },
        jumpWebs() {
            window.location.href = 'https://open.gjwec.com/#/'
        },

        jumpgh(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'coop', query: { num: a, time: timestamp } })
        },
        topOne() {
            this.$refs.mySwiper.$swiper.slideTo(0);
            this.activeIndex = 0
        },
        jumpweb() {
            window.location.href = 'https://www.zhipin.com/gongsi/b6f6de8f10a0e4011HF_3d29GFU~.html'
        },
        jumpgw() {
            window.location.href = 'https://www.zhipin.com/gongsi/b6f6de8f10a0e4011HF_3d29GFU~.html'
        },
    },
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* 第一个轮播图视频 */
.textara {
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    bottom: 15%;
    transform: translate(-50%, -50%);
    height: auto;
    flex-direction: column;
    color: #fff;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.text-cons {
    font-size: 65px;
    padding-bottom: 20px;
}

.text-fonts {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80%;
    font-size: 20px;
    flex-direction: column;
}

.but-tex {
    background: linear-gradient(90deg, #34e5fd 0%, #db9bfe 100%);
    border-radius: 50px;
    /* box-shadow: '0px 4px 8px rgba(52, 229, 253, 0.5), 0px 8px 16px rgba(219, 155, 254, 0.5)'; */
    color: #fff;
    width: 230px;
    position: absolute;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    bottom: 340px;
    cursor: pointer;
    left: 150px;
}

/* 导航栏颜色 */
.top-business-con {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 5;
    width: 100%;
    max-width: 1200px;
    display: flex;
    justify-content: center;
}

.top-business-con .tab-nav {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 0;
    background: rgba(255, 255, 255, 0.5);
    padding: 15px;
    border-radius: 50px;
}

.top-business-con .tab-item {
    padding: 10px 20px;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.3s ease;
    font-size: 16px;
    color: #2c3e50;
}

.top-business-con .tab-item:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #333;
}

.top-business-con .tab-item.active {
    background: linear-gradient(90deg, #BFE9FF 0%, #D6E2FF 100%);
    color: #2D7CFE;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.01);
    border-radius: 50px;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .top-business-con {
        bottom: 80px;
        padding: 0 20px;
    }

    .top-business-con .tab-nav {
        flex-wrap: wrap;
        gap: 10px;
        padding: 10px;
    }

    .top-business-con .tab-item {
        font-size: 14px;
        padding: 8px 15px;
    }
}

@media (max-width: 480px) {
    .top-business-con .tab-nav {
        gap: 5px;
        padding: 8px;
    }

    .top-business-con .tab-item {
        font-size: 12px;
        padding: 6px 12px;
    }

    .strategy-container {
        padding: 0 10px;
    }

    .strategy-row {
        gap: 10px;
    }

    .strategy-item {
        min-height: 220px;
    }

    .strategy-item.expanded {
        min-height: 300px;
    }

    .strategy-icon {
        width: 50px;
        height: 50px;
    }

    .strategy-icon img {
        width: 30px;
        height: 30px;
    }

    .strategy-title {
        font-size: 14px;

    }

    .strategy-subtitle {
        font-size: 10px;
    }

    .strategy-content {
        font-size: 11px;
        padding: 5px;
        min-height: 60px;
    }

    .expand-icon {
        bottom: 5px;
    }

    .expand-icon img {
        width: 20px;
        height: 20px;
    }
}

/* 从左往右 */
.animated-title {
    animation: slideInFromLeft 0.8 ease-out forwards;
    transform: translateX(-100%);
}

@keyframes slideInFromLeft {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

.animated-content {
    animation: slideInFromLeftContent 0.8s ease-out forwards;
    transform: translateX(-100%);
    opacity: 0;
}

@keyframes slideInFromLeftContent {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

/* 顶部按钮 */
.top-nav {
    width: 40px;
    height: 40px;
    position: fixed;
    right: 0em;
    top: 370px;
    z-index: 1000;
    cursor: pointer;
    transition: all 0.3s ease;
}

.top-nav:hover {
    transform: scale(1.1);
}

#mySwiper {
    width: 100%;
    height: 100vh;
    overflow: hidden;
}

.swiper-pagination {
    right: 1em;
}

/* 四个轮播 */
/* 配置分页器的颜色 */
#swiperTop {
    --swiper-pagination-color: #ffffff;
    /* 未选中状态颜色为白色 */
    --swiper-pagination-current-color: #0000ff;
    /* 选中状态颜色为蓝色 */
}

/* 如果想要分页器小圆点的大小和样式进行微调 */
.swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    border-radius: 50%;
}

.swiper-pagination-bullet-active {
    background-color: #0000ff;
    /* 选中的小圆点颜色为蓝色 */
}

.top-pagination {
    position: absolute;
    bottom: 70px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
}

.top-pagination .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    margin: 0 5px;
    background: #fff;
    opacity: 1;
    transition: all 0.3s ease;
}

.top-pagination .swiper-pagination-bullet-active {
    background: #fff;
    opacity: 0.5;
}

/* 1合作方式 */
.tit-news {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    font-weight: 600;
    padding-top: 100px;
}

.twos-con {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 20px;
    width: 65%;
    padding-top: 100px;
    margin-left: 17.5%;
}

.zuob {
    width: 40%;

}

.zuob img {
    width: 95%;
    height: 620px;
    border-radius: 10px;
    object-fit: cover;
}

.two-paginations {
    position: absolute;
    bottom: 10px;
    text-align: center;
}

.youb {
    width: 45%;
    padding: 20px;
    border-radius: 10px;
    text-align: center;
    /* border: 1px solid; */
}

.font-nes {
    color: #606972;
    text-align: left;
    text-indent: 2em;
}

.nes-tit {
    font-size: 40px;
    font-weight: 600;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.img-nes {
    width: 500px;
    padding-top: 40px;
    padding-bottom: 40px;
    display: flex;
    justify-content: flex-start;
}

.img-nes img {
    /* border: 1px solid; */
    width: 310px;
    height: 65px;
}

.jhdd {
    color: #606972;
    text-align: left;
    text-indent: 2em;
}

.nes-but {
    color: #fff;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 80%;
    border-radius: 10px;
    height: 45px;
    margin-top: 40px;
    margin-left: 30px;
}

.butadd {
    cursor: pointer;
    color: #fff;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80%;
    border-radius: 10px;
    height: 45px;
    margin-top: 40px;
    background: linear-gradient(180deg, #43FFF5 0%, #2155FE 100%);
}

/* 每行显示三个图片 */
.image-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 70%;
    margin-left: 15%;
    margin-bottom: 20px;
    margin-top: 40px;

}

#swiperSlideGallery {
    border: 1px solid;
    width: 70%;
    margin-left: 15%;
    margin-top: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

}

.custom-image {
    width: 370px;
    height: 220px;
    border-radius: 10px;
    object-fit: cover;

}

.custom-swiper-pagination {
    position: absolute;
    width: 100%;
    justify-content: center;
    display: flex !important;
    z-index: 15;
    gap: 10px;
    bottom: 20px;
}

.custom-swiper-pagination .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #ccc;
    opacity: 1;
    transition: background 0.3s;
    margin: 0 5px;
}

.custom-swiper-pagination .swiper-pagination-bullet-active {
    background: #2D7CFE;
}

/* 2 团队风采 */
.sy-tits {
    font-size: 28px;
    font-weight: 600;
    padding-top: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
}



/* 3未来规划 */
.video-td {
    position: relative;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.video-td video {
    width: 100vw;
    height: 100vh;
    object-fit: cover;
}

.video-tds {
    position: absolute;
    top: 100px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    flex-direction: column;
}

.td-con {
    color: #333;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
}

.join-btn {
    width: 240px;
    height: 65px;
    background: linear-gradient(180deg, #43FFF5 0%, #2155FE 100%);
    color: #fff;
    font-size: 28px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 40px auto 0 auto;
    cursor: pointer;
    box-shadow: 0 4px 16px rgba(33, 85, 254, 0.12);
    position: absolute;
    bottom: 100px;
}

.td-tit {
    color: #A7A9AC;
    font-size: 18px;
    text-indent: 2em;
    line-height: 30px;
}


/* 4全球战略 */
.qzl-con {
    width: 100%;
}

.qq-tit {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 100px;
    font-size: 28px;
    color: #000;
    font-weight: 600;
}

.qq-img {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    margin-top: 40px;
}

.qq-one {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 32px;
}

.qq-one img {
    width: 400px;
    height: 220px;
    object-fit: cover;
}


/* 5 合作伙伴 */
.video-ref {
    position: relative;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.video-ref video {
    width: 70vw;
    height: 80vh;
    object-fit: cover;
}

.video-overlay {
    position: absolute;
    top: 100px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
}

.reform-con {
    color: #333;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
}

/* 新闻动画效果 - 从左往右 */
.animated-news-item {
    animation: slideInFromLeftNews 1s ease-out forwards;
    transform: translateX(-100%);
    opacity: 0;
}

@keyframes slideInFromLeftNews {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

/* 上排证书从左向右动画 - 居中对齐 */
.animated-cert-left {
    animation: slideInFromLeftCert 1s ease-out forwards;
    transform: translateX(-100%);
    opacity: 0;
}

@keyframes slideInFromLeftCert {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

/* 下排证书整体从右向左动画 */
.animated-bottom-row {
    animation: slideInFromRightRow 1s ease-out forwards;
    transform: translateX(100%);
    opacity: 0;
}

@keyframes slideInFromRightRow {
    0% {
        transform: translateX(100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

.animated-image {
    animation: slideInFromRight 0.8s ease-out forwards;
    transform: translateX(100%);
    opacity: 0;
}

@keyframes slideInFromRight {
    0% {
        transform: translateX(100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

/* 合作伙伴动画 */

.animated-partner-row-delay1 {
    animation: slideInFromRight 1s ease-out forwards;
}

/* 底部导航栏 */
.footer {
    width: 100%;
    height: 340px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    color: #000;
    position: absolute;
    bottom: 0;
}

.footer_top {
    width: 100%;
    height: 300px;
    border-bottom: 1px solid #fff;
    display: flex;
    justify-content: center;
    padding-top: 30px;

}

.footerTopLeft {
    width: 50%;
    height: 210px;
    display: flex;
    justify-content: space-around;
    /* border: 1px solid; */
    margin-top: 20px;
}

.LeftCon p {
    font-size: 27rpx;
    text-align: center;
    color: #989898;
    cursor: pointer;
    line-height: 2.5;
}

.LeftCon h4 {
    color: #000;
    text-align: center;
    cursor: pointer;
    font-size: 18px;
}

.RightCon p {
    color: #989898;
    cursor: pointer;
}

/* 右边四个 */
.footerTopRight {
    height: 240px;
    font-size: 14px;
    position: relative;
    left: 3%;
    width: 40%;
}

.RightCon {
    height: 18%;
    display: flex;
    align-items: center;
}

.RightCon img {
    width: 25px;
    height: 25px;
    margin-right: 15px;
}

.RightCon p {
    color: #000;
    margin: 0;
    line-height: 25px;
}



.footerMidd {
    width: 70%;
    height: 75%;
    border-bottom: 1px solid #cacaca;
}

.code {
    position: absolute;
    right: 18%;
    top: 0;
    width: 35%;
    align-items: center;
    justify-content: space-around;
    display: flex;
}

.codes {
    width: 23%;
    height: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.codes img {
    width: 100%;
    height: 100%;
}

.code h5 {
    margin-top: 10px;
}

.footer_botm {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    font-size: 16px;
}

.card-imgs {
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0;
    object-fit: fill;
    position: relative;
}

.vjs-custom-skin {
    width: 100%;
    height: 100%;
}

.video-js {
    width: 100% !important;
    height: 100% !important;
    min-height: 300px;
}

.video-js video {
    object-fit: cover;
}

/* 响应式布局调整 */
@media (max-width: 768px) {
    .card-imgs {
        max-width: 100%;
        margin-right: 0;
    }

    .card-imgs .video-js {
        min-height: 250px;
    }
}

.gradient-con {
    position: absolute;
    margin-top: -380px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.gradient-text {
    font-size: 70px;
    /* 设置字体大小 */
    font-weight: bold;
    /* 可选的加粗 */
    background: linear-gradient(90deg, #30EDFC 0%, #304EFC 100%);
    -webkit-background-clip: text;
    /* Safari和Chrome支持 */
    background-clip: text;
    /* 适用于Firefox */
    color: transparent;
    /* 使文字透明，从而显示背景渐变 */
    padding-bottom: 30px;
}

.gradient-p {
    font-size: 40px;
    /* 设置字体大小 */
    font-weight: bold;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/join.vue